import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "flex items-center gap-1" }
const _hoisted_3 = { class: "text-base font-bold" }
const _hoisted_4 = {
  key: 0,
  class: "text-base font-bold text-green"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-sm text-primary" }, /*#__PURE__*/_toDisplayString("Akhiri RIT"), -1)
const _hoisted_7 = {
  key: 0,
  class: "pt-2 border-grey-3 px-24px py-16px"
}
const _hoisted_8 = { class: "flex items-center justify-between pt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "Daftar tiket yang terjual di RIT ini", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-red text-sm italic" }, "*Tiket yang belum tampil silahkan ditunggu +- 10 menit setelah dilakukan sinkronisasi", -1)
const _hoisted_11 = { class: "" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "Tidak ada data", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_InputIconRight = _resolveComponent("InputIconRight")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_HjpConfirmationModal = _resolveComponent("HjpConfirmationModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.ritList, (data) => {
      return (_openBlock(), _createElementBlock("div", { key: data }, [
        _createElementVNode("div", {
          class: "flex items-center justify-between px-24px py-16px border-grey-3 background-grey-1 cursor-pointer",
          onClick: ($event: any) => ($setup.selectedRitAct(data.Id))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("i", {
              class: _normalizeClass(data.Id === $setup.selectedRitId ? 'pi pi-angle-down mr-3' : 'pi pi-angle-right mr-3')
            }, null, 2),
            _createElementVNode("div", _hoisted_3, _toDisplayString(data.RouteName), 1)
          ]),
          (data.MsStatusId === 8)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(`Sudah Diakhiri (${$setup.moment(data.UpdatedAt).format('DD MMMM YYYY - HH:mm')})`), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  class: "flex gap-2 extra-submit-button p-1",
                  outlined: true,
                  onClick: ($event: any) => ($setup.showCloseRitDialogAct(data.Id))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]))
        ], 8, _hoisted_1),
        (data.Id === $setup.selectedRitId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("div", null, [
                  _createVNode(_component_InputIconRight, {
                    class: "input-search-header-custom",
                    placeholder: "Cari...",
                    modelValue: $setup.inputSearch,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.inputSearch) = $event)),
                    canClick: true,
                    icon: $setup.icon.svg.searchEva,
                    onSubmitInput: $setup.onSearch,
                    onKeyup: _withKeys($setup.onSearch, ["enter"])
                  }, null, 8, ["modelValue", "icon", "onSubmitInput", "onKeyup"])
                ])
              ]),
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_DataTable, {
                  id: "hjp-data-table",
                  value: $setup.dataSource,
                  paginator: false,
                  class: "table-og hjp-data-table",
                  responsiveLayout: "scroll"
                }, {
                  empty: _withCtx(() => [
                    _hoisted_12
                  ]),
                  loading: _withCtx(() => [
                    _createVNode(_component_ProgressSpinner, { style: {"width":"70px","height":"70px"} })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, { header: "KODE TIKET" }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("p", null, _toDisplayString(slotProps.data.Code), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Column, { header: "KATEGORI" }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("p", null, _toDisplayString(slotProps.data.MsPassengerName), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Column, { header: "ASAL - TUJUAN" }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("p", null, _toDisplayString(`${slotProps.data.Origin} - ${slotProps.data.Destination}`), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Column, { header: "PEMBAYARAN" }, {
                      body: _withCtx((slotProps) => [
                        _createElementVNode("p", null, _toDisplayString(slotProps.data.PaymentType), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["value"]),
                _createElementVNode("div", null, [
                  ($setup.dataSource.length > 0)
                    ? (_openBlock(), _createBlock(_component_Paginator, {
                        key: 0,
                        rows: $setup.filters.pageSize,
                        totalRecords: $setup.filters.totalRecords,
                        onOnPage: $setup.onChangePage
                      }, null, 8, ["rows", "totalRecords", "onOnPage"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createVNode(_component_HjpConfirmationModal, {
      show: $setup.attrModalConfirmation.show,
      imgContent: $setup.attrModalConfirmation.imgContent,
      title: $setup.attrModalConfirmation.title,
      subTitle: $setup.attrModalConfirmation.subTitle,
      btnSubmitTitle: $setup.attrModalConfirmation.btnSubmitTitle,
      onHideDialog: $setup.hidedropOffController,
      onOnSubmit: $setup.dropOffControllerAct,
      onReloadData: $setup.reloadHeader
    }, null, 8, ["show", "imgContent", "title", "subTitle", "btnSubmitTitle", "onHideDialog", "onOnSubmit", "onReloadData"])
  ], 64))
}